import { Outlet, ScrollRestoration } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />
      <main className="pt-20 pb-24 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
      <ScrollRestoration />
    </div>
  );
}
